export const cssWidthToPixelWidth = (cssWidth: string): number => {
  const el = document.createElement("div");
  el.style.display = "none";
  el.style.width = cssWidth;
  document.body.appendChild(el);
  const pixelWidth = window.getComputedStyle(el).getPropertyValue("width");
  document.body.removeChild(el);

  return parseFloat(pixelWidth);
};